import {RefObject} from "react";
import {MessageGlobals} from "./MessageInterface";
import {I18nGlobals} from "../translation/i18nInterface";

/**
 * Globally used {@link MessageLog} variables
 */
export interface MessageLogGlobals {
	showLog: boolean;
}

/**
 * Initialize the {@link MessageLogGlobals}. To be used in a components state.
 */
export function initMessageLogGlobals(): MessageLogGlobals {
	return {
		showLog: false,
	};
}

/**
 * The properties for a {@link MessageLog} component
 */
export interface MessageLogProperties extends MessageLogGlobals, MessageGlobals, I18nGlobals {
	resizeContainer: RefObject<HTMLDivElement>;
}

/**
 * The status for a {@link MessageLog} component
 */
export interface MessageLogStatus {
	logHeight: string;
}